import { render, staticRenderFns } from "./SubProductsProgressOverlay.vue?vue&type=template&id=28c4b9b4&scoped=true"
import script from "./SubProductsProgressOverlay.vue?vue&type=script&lang=js"
export * from "./SubProductsProgressOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c4b9b4",
  null
  
)

export default component.exports